// Pixel-mosaic patterns for SQPDCHI letters (DigiLean-style).
// Each letter uses a consistent 8-row × 6-col grid ('1' = day cell, '0' = background).
// Active cell count ~= 30-34 (accommodates up to 31 days; extras render as faded dashed cells).
// Days are filled left-to-right, top-to-bottom.

export const LETTER_PATTERNS = {
  S: [
    '111110',
    '111111',
    '110000',
    '011110',
    '000011',
    '000011',
    '111111',
    '011111',
  ], // 32 active
  Q: [
    '011110',
    '110011',
    '110011',
    '110011',
    '110011',
    '110111',
    '011110',
    '000011',
  ], // 31 active (with tail)
  P: [
    '111110',
    '111111',
    '110011',
    '110011',
    '111111',
    '111000',
    '110000',
    '110000',
  ], // 32 active
  D: [
    '111100',
    '110110',
    '110011',
    '110011',
    '110011',
    '110011',
    '110110',
    '111100',
  ], // 32 active
  C: [
    '011110',
    '111111',
    '111100',
    '110000',
    '110000',
    '111100',
    '111111',
    '011110',
  ], // 32 active
  H: [
    '110011',
    '110011',
    '110011',
    '111111',
    '111111',
    '110011',
    '110011',
    '110011',
  ], // 34 active
  I: [
    '111111',
    '011110',
    '011110',
    '011110',
    '011110',
    '011110',
    '011110',
    '111111',
  ], // 36 active - extras beyond day 31 become dashed
};

// Convert pattern to ordered list of {row, col} for active cells
export function getLetterCells(letterKey) {
  const pattern = LETTER_PATTERNS[letterKey];
  if (!pattern) return [];
  const cells = [];
  for (let r = 0; r < pattern.length; r++) {
    const row = pattern[r];
    for (let c = 0; c < row.length; c++) {
      if (row[c] === '1') cells.push({ row: r, col: c });
    }
  }
  return cells;
}

export function getLetterDims(letterKey) {
  const pattern = LETTER_PATTERNS[letterKey];
  return { rows: pattern.length, cols: pattern[0].length };
}
